import React from 'react';

import User from '../../components/user';

const Student = () => <User label={'Contact'} />

export default Student
